export default "/images/camera.svg?699d230654d2f71111668bd861024de5";